import { TimeOffInfoEntity } from './time-off-info.entity';
import { WorkloadCaseEntity } from './workload-case.entity';

export class WorkloadMemberEntity {
  public userId!: string;
  public firstName!: string;
  public lastName!: string;
  public role!: string;
  public email!: string;
  public phone!: string;
  public teams!: string[];
  public activeCasesCount!: number;
  public capacity!: number;
  public utilizationPercent!: number;
  public overdueCount!: number;
  public highPriorityCount!: number;
  public closedThisMonthCount!: number;
  public isOverCapacity!: boolean;
  public timeOff!: TimeOffInfoEntity | null;
  public cases!: WorkloadCaseEntity[];
  public closedHiddenCount!: number;

  public effectiveCapacity?: number;
  public currentCaseCount?: number;
  public atRiskCount?: number;
  public isOnTimeOff?: boolean;
  public isManager?: boolean;
}
